<template>
  <div class="page-content">
    <div class="rule-detail">
      <el-breadcrumb separator="/" class="egl-breadcrumb">
        <el-breadcrumb-item :to="{ path: '/discountRules' }">{{ $locale("sideMenu.performance.discountRuleTemplate") }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ getTitle() }}</el-breadcrumb-item>
      </el-breadcrumb>

      <RuleTemplateForm />
    </div>
  </div>
</template>
<script>
import "@/assets/style/rulesTemplate.less";
import RuleTemplateForm from "@/components/DiscountRuleTemplate/RuleTemplateForm.vue";

export default {
  methods: {
    getTitle() {
      return this.$route.path.indexOf("create") > -1 ?
        this.$locale("discountRules.createRule") :
        this.$locale("discountRules.editTitle");
    },
  },
  components: {
    RuleTemplateForm
  }
};
</script>
<style lang="less" scoped>
  .rule-detail {
    overflow: hidden;
  }
</style>